var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandLogoLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 38,
    viewBox: "0 0 136 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.9616C0 12.1873 4.83389 7.34619 12.6362 7.34619C19.9083 7.34619 25.2724 12.1461 25.2724 19.0534C25.2724 25.8688 20.3076 30.6277 13.5689 30.6277C9.48778 30.6277 6.51937 28.9538 4.92226 26.856V38H0.0130914L0 18.9616ZM12.6362 26.4637C17.2934 26.4637 20.1309 23.249 20.1309 19.0027C20.1309 14.8894 17.1854 11.5038 12.6362 11.5038C8.08704 11.5038 5.00081 14.5888 5.00081 19.0027C5.00081 23.4167 8.07067 26.4637 12.6362 26.4637Z",
    fill: "#162056"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8242 7.64276H49.7334V21.4446C49.7334 27.5766 45.4788 30.6205 39.2278 30.6205C32.9768 30.6205 28.7549 27.5766 28.7549 21.4446V7.64276H33.6641V20.6694C33.6641 24.3113 35.5263 26.4565 39.2081 26.4565C42.89 26.4565 44.8242 24.3176 44.8242 20.6694V7.64276Z",
    fill: "#162056"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3153 17.2877C70.3153 13.6459 68.4531 11.4943 64.7286 11.4943C61.0042 11.4943 59.1846 13.6364 59.1846 17.2782V30.2258H54.2754V16.5189C54.2754 10.3868 58.53 7.38727 64.7483 7.38727C70.9666 7.38727 75.2539 10.3868 75.2539 16.5189V30.2352H70.3447L70.3153 17.2877Z",
    fill: "#162056"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6206 1.89846L84.5854 0V7.6413H89.3735L88.6207 11.4572H84.5887V18.8296C84.5887 24.4458 87.7371 28.3029 89.1542 30.2203H83.6559C82.5039 28.518 79.6206 24.9173 79.6206 18.7441V1.89846Z",
    fill: "#162056"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.563 7.34653C110.711 7.38133 116.2 11.6307 116.242 19.0031C116.285 26.3754 110.744 30.6217 103.563 30.6217C96.383 30.6217 90.8389 26.366 90.8389 19.0031C90.8389 11.6402 96.7331 7.30223 103.563 7.34653ZM103.563 26.464C107.906 26.464 111.091 23.591 111.055 19.0031C111.019 14.4151 107.864 11.4947 103.563 11.4947C99.4397 11.4599 95.9837 14.374 95.9837 19.0031C95.9837 23.6322 99.2172 26.464 103.563 26.464Z",
    fill: "#162056"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.145 30.1474C132.483 30.1474 136 26.7475 136 22.5536C136 18.3596 132.483 14.9597 128.145 14.9597C123.807 14.9597 120.291 18.3596 120.291 22.5536C120.291 26.7475 123.807 30.1474 128.145 30.1474Z",
    fill: "#E30613"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogoLogin);
export default __webpack_public_path__ + "static/media/brand-logo-login.11196f256399512fbb7945105d3f8754.svg";
export { ForwardRef as ReactComponent };